import PARTNERS from './PartnersList';

export const getNewPartners = (blackList?: string[]) => {
  if (!blackList) return PARTNERS;

  return PARTNERS.filter(
    partner => !blackList.includes(partner.name.toLowerCase())
  );
};
